import { Layout, Avatar, Dropdown, Space, Typography } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { GET_MEMBER } from "../../services/apiEndPoints";
import axios from "../../services/axiosInstance";
import { useEffect, useState } from "react";
import { toastSuccess } from "../../utils/toast";

const { Header } = Layout;
const { Text } = Typography;

const AppHeader = () => {
  const navigate = useNavigate();
  const [memberName, setMemberName] = useState("Admin");

  const handleLogout = () => {
    localStorage.removeItem("token");
    toastSuccess("Logged out successfully");
    navigate("/login");
  };

  const getUserDetails = async () => {
    try {
      const res = await axios.get(GET_MEMBER, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res?.data?.memberName) {
        setMemberName(res.data.memberName);
      }
    } catch {
      // silently ignore
    }
  };

  const items = [
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      danger: true,
      onClick: handleLogout,
    },
  ];

  useEffect(() => {
    getUserDetails();
  }, []);

  const initials = memberName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <Header
      style={{
        position: "fixed",
        top: 0,
        zIndex: 1000,
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
        boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
      }}
    >
      {/* Left: Logo + Title */}
      <Space
        align="center"
        style={{ cursor: "pointer", gap: 10 }}
        onClick={() => navigate("/")}
      >
        <div
          style={{
            width: 34,
            height: 34,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src="https://warehouse-prod-bucket-public.s3.ap-south-1.amazonaws.com/assets/logo.png"
            alt="Logo"
            style={{
              height: 30,
              width: 30,
              objectFit: "contain",
              padding: 2,
              border: "1.5px solid #fff",
              borderRadius: 4,
              background: "white"
            }}
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
        </div>
        <div>
          <Text
            strong
            style={{
              fontSize: 15,
              color: "#f1f5f9",
              display: "block",
              lineHeight: "1.2",
            }}
          >
            Access Warehousing
          </Text>
          <Text
            style={{
              fontSize: 10,
              color: "#64748b",
              display: "block",
              lineHeight: "1.2",
              letterSpacing: "0.5px",
            }}
          >
            ADMIN PORTAL
          </Text>
        </div>
      </Space>

      {/* Right: user dropdown */}
      <Dropdown menu={{ items }} trigger={["click"]}>
        <Space
          className="header-user-btn"
          style={{
            cursor: "pointer",
            padding: "6px 14px",
            borderRadius: 8,
            transition: "background 0.18s",
          }}
          onMouseEnter={(e) =>
            ((e.currentTarget as HTMLElement).style.background =
              "rgba(255,255,255,0.06)")
          }
          onMouseLeave={(e) =>
            ((e.currentTarget as HTMLElement).style.background = "transparent")
          }
        >
          <Avatar
            size={30}
            style={{
              background: "linear-gradient(135deg, #1677ff, #0ea5e9)",
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            {initials}
          </Avatar>
          <Text style={{ color: "#cbd5e1", fontSize: 13, fontWeight: 500 }}>
            {memberName}
          </Text>
        </Space>
      </Dropdown>
    </Header>
  );
};

export default AppHeader;
